<template>
  <div
    class="availability-calendar-day-main py-3 text-center border border-left-0"
    :class="{ selected }"
  >
    <div class="px-2 py-3 rounded font-weight-bold" @click="onSelectDay">
      {{ day.name }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'AvailabilityCalendarDay',
  props: {
    day: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onSelectDay() {
      this.$emit('select', this.selected ? null : this.day);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/shared/scss/config/_colors.scss';
@import '@/scss/availability_calendar_colors.scss';

.availability-calendar-day-main {
  --day-bg: #{$calendar-accent};
  --day-fg: #435357;
}
.availability-calendar-day-main > div {
  cursor: pointer;
  color: var(--day-fg) !important;
  background-color: var(--day-bg) !important;
}
.availability-calendar-day-main.selected {
  --day-bg: #ff745c;
  --day-fg: #fff;
}

.with-mobile {
  width: 190px !important;
  box-sizing: border-box;
}
</style>
